import TabContent from './TabContent';

export default TabContent;